import {
  EditorActionsManager,
  IVector3,
  UpdateDataAction,
  VirtualChildComponent,
  VirtualChildData,
} from '@easytwin/runtime';
import * as React from 'react';
import set from 'lodash-es/set';
import { message } from '@easyv/react-components';
import { deepClone, isIVector3Array, isLonLatArray, isNil } from '@/utils';
import { ImmerFormItem } from '@/UIGenerator/uicomponents/ImmerFormItem';
import { ProInput } from '@/UIGenerator';
import { CopyIdNode } from './CopyIdNode';
import { CodeEditor } from '@/UIGenerator/uicomponents/CodeEditor';

interface VirtualChildDataPointProps {
  comp: VirtualChildComponent;
  compJson: VirtualChildData<any>;
  mode?: 'lonLat' | 'xyz';
}

export const VirtualChildDataPoints: React.FC<VirtualChildDataPointProps> = (props) => {
  const { comp, compJson, mode = 'xyz' } = props;

  const editorActionMgr = comp.engine.getManager(EditorActionsManager);

  const handleUpdate = (name: string, value: unknown) => {
    if (!compJson) return;

    const newData = deepClone(compJson);
    set(newData, name, value);
    comp.updateData(newData, false);
  };

  const handleConfirm = (name: string, value: unknown) => {
    if (!compJson) return;
    const newData = deepClone(compJson);
    set(newData, name, value);
    editorActionMgr.execute(new UpdateDataAction(comp, newData));
  };

  const [code, setCode] = React.useState<string>();
  // const geographicProjectionEnabled = false;

  // const mode: PositionMode = React.useMemo(
  //   () => (geographicProjectionEnabled && positionMode === 'lonLat' ? 'lonLat' : 'xyz'),
  //   [positionMode, geographicProjectionEnabled],
  // );

  React.useEffect(() => {
    if (compJson) {
      const target = compJson.config.points;
      if (mode === 'lonLat') {
        const res = target.map((p: IVector3) => {
          return comp.scene.geoTransform.sceneToGeo(p);
        });
        const json = JSON.stringify(res, null, '\t');
        setCode(json);
      } else {
        const json = JSON.stringify(target, null, '\t');
        setCode(json);
      }
    } else {
      setCode('');
    }
  }, [compJson, mode]);

  return (
    <div>
      <ImmerFormItem label='ID'>
        <ProInput
          disabled
          name='id'
          suffix={<CopyIdNode id={compJson.id} />}
          value={compJson.id}
          onBlur={handleConfirm}
        />
      </ImmerFormItem>
      <ImmerFormItem label='名称'>
        <ProInput
          name='name'
          allowEmpty={false}
          onChange={handleUpdate}
          onBlur={handleConfirm}
          value={compJson.name}
        />
      </ImmerFormItem>
      <ImmerFormItem label='点位数据' labelVerticalAlign='top'>
        <CodeEditor
          value={code}
          language='json'
          height={400}
          onCompleted={(v) => {
            try {
              if (isNil(v) || isNil(compJson)) return false;
              const o = JSON.parse(v);
              if (mode === 'xyz' && isIVector3Array(o, true)) {
                handleConfirm('config.points', o);
              } else if (mode === 'lonLat' && isLonLatArray(o)) {
                // const poses = o.map((o) => {
                //   return world.projectGeographicToPosition(o.lon, o.lat, o.alt);
                // });
                const poses = o;
                handleConfirm('config.points', poses);
              } else throw new Error('输入格式有误');
              return true;
            } catch (error) {
              message.error((error as Error).message);
              return false;
            }
          }}
        />
      </ImmerFormItem>
    </div>
  );
};
